module.exports = __webpack_public_path__ + "static/media/slider_vector_next.7061d422.svg";